import React from 'react';
import { TSquare } from '../../types/TSquare';
import './Square.scss';

const Square = ({ onClick, value, customClass }:
  {onClick: () => void, value: TSquare, customClass: string}) => (
    <button
      type="button"
      className={customClass}
      onClick={() => onClick()}
    >
      {value}
    </button>
);

export default Square;
